import React from "react";
import { education, certifications } from "../content";
import { Cap, Certificate } from "./Icons";

const Education = () => (
  <section id="education" className="section section--ruled">
    <div className="shell shell--narrow">
      <div className="section-head">
        <p className="eyebrow">Education &amp; certification</p>
        <h2 className="section-title">Where it started</h2>
      </div>

      <div className="stack-list reveal">
        {education.map((e) => (
          <article className="card entry" key={e.institution}>
            <span className="entry-mark" aria-hidden="true">
              <Cap />
            </span>

            <div>
              <div className="entry-head">
                <h3 className="entry-title">{e.institution}</h3>
                <span className="meta">{e.period}</span>
              </div>

              <p className="entry-sub">{e.degree}</p>
              <p className="meta" style={{ marginTop: 4 }}>
                {e.location}
              </p>

              {e.desc && <p className="entry-desc">{e.desc}</p>}

              {e.stats.length > 0 && (
                <div className="stat-row">
                  {e.stats.map((s) => (
                    <div className="stat" key={s.key}>
                      <div className="stat-val">{s.val}</div>
                      <div className="stat-key">{s.key}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </article>
        ))}

        {certifications.map((c) => (
          <article className="card entry" key={c.title}>
            <span className="entry-mark" aria-hidden="true">
              <Certificate />
            </span>

            <div>
              <div className="entry-head">
                <h3 className="entry-title">{c.title}</h3>
                <span className="meta">{c.date}</span>
              </div>
              <p className="entry-sub">{c.issuer}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Education;
